import { render } from "./service.vue?vue&type=template&id=6b6f3b36&scoped=true"
import script from "./service.vue?vue&type=script&lang=js"
export * from "./service.vue?vue&type=script&lang=js"

import "./service.vue?vue&type=style&index=0&id=6b6f3b36&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6b6f3b36"

export default script